import { FileDown, RotateCcw } from "lucide-react";

export const B2BOrders = ({ orders, onDownloadPdf, onReorder }) => (
  <div className="mb-10" data-testid="b2b-orders-section">
    <h2 className="font-serif-display font-bold text-2xl mb-4">I tuoi ordini</h2>
    <div className="space-y-3">
      {orders.map((o) => (
        <div key={o.id} data-testid={`b2b-order-${o.id}`} className="rounded-2xl border border-[#E7E0D8] bg-white p-5 flex flex-wrap items-center justify-between gap-4">
          <div className="min-w-0">
            <p className="font-mono-accent text-xs text-[#78716C]">#{o.id.slice(0, 8)} — {new Date(o.created_at).toLocaleDateString("it-IT")}{o.delivery_date ? ` · consegna ${new Date(o.delivery_date).toLocaleDateString("it-IT")}` : ""}</p>
            <p className="text-sm text-[#44403C] mt-1 truncate max-w-xl">{o.items.map((i) => `${i.name} ×${i.quantity}`).join(" · ")}</p>
          </div>
          <div className="flex items-center gap-3">
            <span className="font-serif-display font-bold text-lg">{o.total.toFixed(2).replace(".", ",")} €</span>
            <span data-testid={`b2b-order-status-${o.id}`} className={`rounded-full px-4 py-1.5 text-xs font-semibold ${o.payment_status === "paid" ? "bg-[#2E8A57]/10 text-[#2E8A57]" : "bg-[#F5F0EB] text-[#78716C]"}`}>{o.status}</span>
            <button data-testid={`b2b-order-pdf-${o.id}`} onClick={() => onDownloadPdf(o.id)} className="inline-flex items-center gap-1.5 rounded-full border border-[#E7E0D8] text-[#44403C] px-4 py-2 text-xs font-semibold hover:border-[#2E8A57] hover:text-[#2E8A57] transition-colors">
              <FileDown className="w-3.5 h-3.5" /> PDF
            </button>
            <button data-testid={`b2b-reorder-${o.id}`} onClick={() => onReorder(o)} className="inline-flex items-center gap-1.5 rounded-full border border-[#2E8A57] text-[#2E8A57] px-4 py-2 text-xs font-semibold hover:bg-[#2E8A57] hover:text-white transition-colors">
              <RotateCcw className="w-3.5 h-3.5" /> Riordina
            </button>
          </div>
        </div>
      ))}
    </div>
    <h2 className="font-serif-display font-bold text-2xl mt-10 mb-1">Listino riservato</h2>
  </div>
);
